module.exports = __webpack_public_path__ + "img/Weapon_182.39be0e1e.png";